import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link as NavLink } from 'react-router-dom';
import { push } from 'connected-react-router';
import { withStyles } from '@material-ui/core/styles';
import Moment from 'react-moment';
import {
  CircularProgress,
  Typography,
  Button,
  SvgIcon,
  Divider,
  IconButton,
  withWidth,
  Link,
  Slide,
  Hidden
} from '@material-ui/core';
import VisibilitySensor from 'react-visibility-sensor';

import { ChevronRight } from '@material-ui/icons';
import { Helmet } from 'react-helmet';
import { ReactComponent as MessageIcon } from '../../images/Icons/message-circle.svg';
import { ReactComponent as EyeIcon } from '../../images/Icons/eye.svg';
import { ReactComponent as HeartIcon } from '../../images/Icons/heart.svg';
import { ReactComponent as ShareIcon } from '../../images/Icons/share.svg';
import { ReactComponent as ShopBagIcon } from '../../images/Icons/shopbag.svg';
import { ReactComponent as HammerIcon } from '../../images/Icons/martillo-02.svg';
import { ReactComponent as ZapIcon } from '../../images/Icons/zap.svg';
import LoadingGif from '../../images/Loading.gif';
import {
  PRODUCT_DETAIL_REQUESTED,
  PRODUCT_DETAIL_RETRIEVED,
  PRODUCT_DETAIL_FAILED,
  SHOPPING_CART_ADD_REQUESTED,
  SHOPPING_CART_ADD_SUCCESSFULL,
  DROP_NOTIFICATION_SUCCESSFULL
} from '../../redux/actions/types';
import numberWithCommas from '../../utils/numberWithCommas';
import normalizeString from '../../utils/normalizeString';
import { getProduct } from '../../redux/actions/product';
import { getCart, addToCart } from '../../redux/actions/user';
import abbreviateNumbers from '../../utils/abbreviateNumbers';
import RTVFavouriteButton from '../../commons/RTVFavouriteButton';
import ProductCarousel from './ProductCarousel';
import FaqSection from './FaqSection';
import Gallery from './Gallery';
import Shipping from './Shipping';
import Comments from './Comments';
import ProductTags from './ProductTags';
import UserCard from '../../commons/UserCard';
import RTVMenu from '../../commons/RTVMenu';
import ShareToSocialMenu from '../../commons/menus/ShareToSocialMenu';
import MailShareDialog from '../../commons/dialogs/RTVMailShareDialog';
import OfferButton from './OfferButton';
import RTVNotifyAvailability from '../../commons/RTVNotifyAvailability';
import Analytics from '../../services/Analytics';
import { ReactComponent as AlertIcon } from '../../images/Icons/info.svg';
import RTVDialogButton from '../../commons/RTVDialogButton';
import ColorSelector from '../../commons/ColorSelector';
import i18next from 'i18next';
import { expressToggle } from '../../redux/actions/app';

const styles = theme => ({
  root: {
    padding: theme.spacing(4),
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 1, 3, 1)
    }
  },
  purchaseButton: {
    '& > *': {
      fontSize: '1.2rem'
    }
  },
  loadingWrapper: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  productSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'auto auto',
    gridTemplateAreas: `
      'gallery purchase'
      'profile purchase'
    `,
    gridColumnGap: theme.spacing(2),
    gridRowGap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      // This doesn't fix it 100% of the time.
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      width: '100%',
      '& > *': {
        width: '100%'
      }
    }
  },
  gallerySection: {
    gridArea: 'gallery'
  },
  profileSection: {
    gridArea: 'profile'
  },
  purchaseSection: {
    gridArea: 'purchase',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1)
    }
  },
  priceSection: {
    display: 'flex',
    margin: 0,
    alignItems: 'baseline',
    '& > *': {
      margin: theme.spacing(1, 1, 0, 1)
    }
  },
  strikedText: {
    textDecoration: 'line-through'
  },
  secondaryButton: {
    fontWeight: 500,
    color: theme.palette.secondary.main,
    background: theme.palette.primary.light,
    '&:hover': {
      background: theme.palette.primary.light,
      color: theme.palette.primary.main
    }
  },
  purchaseButtonGroup: {
    minWidth: '350px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridColumnGap: theme.spacing(1),
    gridRowGap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      minWidth: 'unset',
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      '& > *': {
        width: '100%',
        margin: theme.spacing(1)
      }
    }
  },
  buttonIcon: {
    marginLeft: theme.spacing(1),
    '& > svg': {
      stroke: theme.palette.primary.main
    }
  },
  categorySection: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2)
  },
  visitsSection: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '0.9rem',
    color: '#707070'
  },
  activeIcon: {
    fill: theme.palette.secondary.main,
    '& path': {
      fill: theme.palette.secondary.main,
      stroke: theme.palette.secondary.main
    }
  },
  likes: {
    display: 'flex',
    alignItems: 'center'
  },
  eyeIcon: {
    marginRight: theme.spacing(1)
  },
  shareFloating: {
    backgroundColor: '#f5f5f5',
    position: 'absolute',
    right: 0,
    top: '25vh',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    padding: theme.spacing(1),
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '10px',
    zIndex: 5
  },
  description: {
    fontWeight: 400,
    color: '#707070',
    maxWidth: '400px',
    textAlign: 'center',
    lineHeight: '1.3'
  },
  primaryPrice: {
    fontWeight: 600,
    fontSize: '1.8rem'
  },
  discountAmount: {
    fontWeight: 600,
    color: theme.palette.primary.main
  },
  treeCategory: {
    fontWeight: 500,
    textDecoration: 'none',
    color: '#707070'
  },
  treeCategorySelected: {
    fontWeight: 500,
    textDecoration: 'none',
    color: theme.palette.primary.main
  },
  seeMore: {
    fontWeight: 400,
    cursor: 'pointer',
    textDecoration: 'underline',
    textAlign: 'right',
    color: theme.palette.secondary.main
  },
  profileMiniature: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      justifyContent: 'center'
    }
  },
  fixedActions: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    position: 'fixed',
    top: 'calc(5vh + 80px)',
    zIndex: 6,
    right: 0,
    '& > *': {
      margin: '2px'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  fixedActionButton: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.3)',
    '& > *': {
      display: 'flex',
      alignItems: 'center',
      fontSize: '0.5rem',
      padding: 0,
      margin: 0
    }
  },
  activeIconFixed: {
    fill: '#fff',
    '& path': {
      fill: '#fff',
      stroke: '#fff'
    }
  },
  discountSection: {
    padding: theme.spacing(1),
    backgroundColor: '#F7F5B5',
    borderRadius: '5px'
  },
  productDetail: {
    display: 'flex',
    alignItems: 'center'
  }
});

const translateCondition = condition => {
  switch (condition) {
    case 'CONDITION_LIKE_NEW': {
      return 'Como nuevo';
    }
    case 'CONDITION_NEW_WITH_TAG': {
      return 'Nuevo con etiqueta';
    }
    case 'CONDITION_NEW_WITHOUT_TAG': {
      return 'Nuevo sin etiqueta';
    }
    case 'CONDITION_USED': {
      return 'Usado';
    }
    default:
      return '';
  }
};

const renderOffer = offer => {
  const dateLive = offer.date_edited;
  if (!dateLive) {
    return null;
  }

  const date = new Date(Date.parse(dateLive));
  date.setHours(date.getHours() + 48);

  return (
    <Typography
      color="primary"
      component="span"
      style={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}
    >
      <SvgIcon viewBox="0 0 34.587 35.882" style={{ marginRight: '4px' }}>
        <HammerIcon />
      </SvgIcon>
      En oferta{' '}
      <Typography style={{ fontWeight: 400, marginLeft: '4px' }}>
        hasta el <Moment date={date} format="DD/MM" locale="es" /> a las{' '}
        <Moment date={date} format="LT" locale="es" />
      </Typography>
    </Typography>
  );
};

const renderPromotion = promo => {
  let text;
  switch (promo.type) {
    case 'TWO_FOR_ONE':
      text = 'Promo 2x1';
      break;
    case 'THREE_FOR_TWO':
      text = 'Promo 3x2';
      break;
    case 'TWENTY_PERCENT':
      text = '20% off adicional';
      break;
    case 'THIRTY_PERCENT':
      text = '30% off adicional';
      break;
    case 'FORTY_PERCENT':
      text = '40% off adicional';
      break;
    case 'FREE_SHIPPING':
      text = 'Envío gratis';
      break;
    case 'FIXED_SHIPPING':
      text = 'Envío fijo a $' + promo.type_parameter;
      break;
    default:
      text = 'En promo';
  }

  return (
    <>
      <div style={{ display: 'flex' }}>
        <Typography
          color="primary"
          component="span"
          style={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}
        >
          <SvgIcon
            viewBox="0 0 43.5 58.889"
            style={{ marginRight: '4px', marginLeft: '40px' }}
          >
            <ZapIcon />
          </SvgIcon>
          {text}
          <Typography
            style={{ fontWeight: 400, marginLeft: '4px', marginRight: '32px' }}
          >
            hasta el <Moment date={promo.date_end} format="DD/MM" locale="es" />{' '}
            a las <Moment date={promo.date_end} format="LT" locale="es" />
          </Typography>
          <RTVDialogButton
            rtvDialogProps={{
              title: 'Importante!',
              message:
                'Acordate: aplicar esta promo en el carrito haciendo click en "Descuentos"'
            }}
            childrenStyle={{ marginLeft: '4px' }}
          >
            <SvgIcon color="primary">
              <AlertIcon />
            </SvgIcon>
          </RTVDialogButton>
        </Typography>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Typography
          color="primary"
          style={{ fontWeight: 400, marginLeft: '4px', fontSize: '14px' }}
        >
          {i18next.t('applyThisDiscount', { ns: 'products' })}
        </Typography>
      </div>
    </>
  );
};

const calculateDiscount = (original, selling) =>
  100 - ((selling * 100) / original).toFixed();

class Product extends Component {
  constructor(props) {
    super(props);

    this.shareRef = React.createRef();

    this.state = {
      loading: true,
      product: props.product || {},
      openDescription: false,
      productVisible: true,
      shareMenu: false,
      mailDialog: false,
      mailString: '',
      disabledPurchaseButton: false
    };
  }

  componentDidMount() {
    const { productID } = this.props.match.params;
    this.props.getProduct(productID);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.match.params.productID !== this.props.match.params.productID
    ) {
      this.props.getProduct(this.props.match.params.productID);
    }

    if (prevProps.cartStatus !== this.props.cartStatus) {
      if (this.props.cartStatus === SHOPPING_CART_ADD_REQUESTED) {
        // Shouls load the purchase button while we add to the cart.
      }

      if (this.props.cartStatus === SHOPPING_CART_ADD_SUCCESSFULL) {
        this.props.history.push('/checkout/carrito');
      }
    }

    if (prevProps.status !== this.props.status) {
      if (this.props.status === PRODUCT_DETAIL_REQUESTED) {
        this.setState({ loading: true });
      }
      if (this.props.status === PRODUCT_DETAIL_RETRIEVED) {
        if (this.props.location.hash === '#comments') {
          this.scrollIntoComments();
        }

        Analytics.visitProduct(this.props.product);

        this.setState({
          loading: false,
          product: this.props.product
        });
      }
      if (this.props.status === PRODUCT_DETAIL_FAILED) {
        if (this.props.error.status && this.props.error.status === 404) {
          this.props.push('/product-not-found');
        }
      }
      if (this.props.status === DROP_NOTIFICATION_SUCCESSFULL) {
        this.setState({ product: this.props.product });
      }
    }
  }

  scrollIntoComments = () => {
    const comments = document.querySelector('#comments');
    if (comments) {
      comments.scrollIntoView(true);
    }
  };

  visibilityChange = visible => {
    this.setState({ productVisible: visible });
  };

  handlePurchase = () => {
    if (this.state.disabledPurchaseButton) {
      return;
    }
    this.setState({ disabledPurchaseButton: true });
    if (!this.props.user) {
      this.props.expressToggle(true, {
        entity: 'Product',
        identifier: this.state.product.id
      });
      return;
    }
    this.props.addToCart(this.state.product.id);
  };

  handleNotificationRequest = () => {
    // unimplemented
  };

  handleOpenShareMenu = () => {
    this.setState({ shareMenu: true });
  };

  openMailDialog = () => {
    this.setState({ mailDialog: true });
  };

  setMailString = mailString => {
    this.setState({ mailString });
  };

  handleMailDialogClose = () => {
    this.setState({ mailDialog: false });
  };

  confirmMailDialog = () => {
    const ProductOwnerText =
      'Mirá+el+producto+que+vendo+en+Renová+Tu+Vestidor!';
    const ProductViewerText =
      'Mirá+la+oferta+que+encontré+en+Renová+Tu+Vestidor!';

    window.open(
      `mailto:${this.state.mailString}?&body=${
        this.props.loggedInUser &&
        this.props.loggedInUser.id === this.props.product.user.id
          ? ProductOwnerText
          : ProductViewerText
      }+${window.encodeURIComponent(
        `${process.env.REACT_APP_WEB_URL}/producto/id/${this.props.product.user.id}`
      )}`,
      '_blank'
    );
    this.handleMailDialogClose();
  };

  render() {
    const { classes, product, loggedInUser, isLoggedIn } = this.props;

    if (this.state.loading || !product) {
      return (
        <div className={classes.loadingWrapper}>
          <img src={LoadingGif} alt="loading" />
          <Typography variant="h6" color="primary">
            Cargando Producto
          </Typography>
        </div>
      );
    }

    const category = normalizeString(
      product.sub_sub_category.sub_category.category.name
    );
    const subCategory = normalizeString(
      product.sub_sub_category.sub_category.name
    );
    const subSubCategory = normalizeString(product.sub_sub_category.name);

    let primaryPrice = product.selling_price;
    if (product.user.promotion !== null) {
      if (product.user.promotion.type === 'TWENTY_PERCENT') {
        primaryPrice = (primaryPrice * 0.8).toFixed(1);
      }
      if (product.user.promotion.type === 'THIRTY_PERCENT') {
        primaryPrice = (primaryPrice * 0.7).toFixed(1);
      }
      if (product.user.promotion.type === 'FORTY_PERCENT') {
        primaryPrice = (primaryPrice * 0.6).toFixed(1);
      }
    } else if (product.selling_price !== product.final_price) {
      primaryPrice = product.final_price;
    }

    let discount = null;
    if (product.offers.length && product.offers[0].status === 'STATUS_LIVE') {
      discount = { type: 'offer', render: renderOffer(product.offers[0]) };
    }
    if (product.user.promotion !== null) {
      discount = {
        type: 'promotion',
        render: renderPromotion(product.user.promotion)
      };
    }

    return (
      <>
        <div className={classes.root}>
          <Helmet>
            <title>{`RTV - ${product.title}`}</title>
            <meta property="og:title" content={`${product.title}`} />
            <meta property="og:type" content="product" />
            <meta
              property="product:original_price:amount"
              content={`${product.original_price}`}
            />
            <meta
              property="product:sale_price:amount"
              content={`${product.selling_price}`}
            />
            <meta
              property="og:description"
              content={`${product.description}`}
            />
            <meta
              property="og:image"
              content="https://cdn.renovatuvestidor.com/mktg/compartir_vestidor_arg.jpg"
            />
          </Helmet>
          <MailShareDialog
            open={this.state.mailDialog}
            mailString={this.state.mailString}
            setMailString={this.setMailString}
            onClose={this.handleMailDialogClose}
            onConfirm={this.confirmMailDialog}
          />
          <RTVMenu
            transition
            open={this.state.shareMenu}
            anchorEl={this.shareRef.current}
            onClose={() => this.setState({ shareMenu: false })}
          >
            <ShareToSocialMenu
              path={`/producto/id/${product.id}`}
              isOwner={isLoggedIn && loggedInUser.id === product.user.id}
              openMailDialog={this.openMailDialog}
              type="Product"
            />
          </RTVMenu>
          {this.props.width !== 'xs' && this.props.width !== 'sm' && (
            <div className={classes.shareFloating}>
              <div className={classes.likes}>
                <RTVFavouriteButton product={product}>
                  {favProps => (
                    <IconButton onClick={favProps.onClick}>
                      <SvgIcon style={{ marginRight: '4px' }} fontSize="small">
                        <HeartIcon
                          className={
                            favProps.favourite ? classes.activeIcon : ''
                          }
                        />
                      </SvgIcon>
                      <Typography
                        variant="body2"
                        style={{ marginRight: '8px' }}
                      >
                        {favProps.justActed &&
                          favProps.favourite &&
                          product.count_favourite + 1}
                        {favProps.justActed &&
                          !favProps.favourite &&
                          product.count_favourite - 1}
                        {!favProps.justActed && product.count_favourite}
                      </Typography>
                    </IconButton>
                  )}
                </RTVFavouriteButton>
              </div>
              <Divider />
              <IconButton
                onClick={this.handleOpenShareMenu}
                ref={this.shareRef}
              >
                <SvgIcon fontSize="small">
                  <ShareIcon />
                </SvgIcon>
              </IconButton>
            </div>
          )}
          <Slide in={!this.state.productVisible} timeout={200} direction="left">
            <div className={classes.fixedActions}>
              {product.status !== 'STATUS_RESERVED' && (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.fixedActionButton}
                  onClick={this.handlePurchase}
                  disabled={
                    product.status !== 'STATUS_LIVE' ||
                    this.state.disabledPurchaseButton
                  }
                >
                  <SvgIcon fontSize="small" style={{ marginRight: '8px' }}>
                    <ShopBagIcon />
                  </SvgIcon>
                  {product.status === 'STATUS_FINISHED' ? 'VENDIDO' : 'COMPRAR'}
                </Button>
              )}
              <RTVFavouriteButton product={product}>
                {favProps => (
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.fixedActionButton}
                    onClick={favProps.onClick}
                  >
                    {favProps.loading ? (
                      <CircularProgress
                        size={20}
                        style={{ marginRight: '8px' }}
                      />
                    ) : (
                      <SvgIcon fontSize="small" style={{ marginRight: '8px' }}>
                        <HeartIcon
                          className={
                            favProps.favourite ? classes.activeIconFixed : ''
                          }
                        />
                      </SvgIcon>
                    )}
                    FAVORITO
                  </Button>
                )}
              </RTVFavouriteButton>
            </div>
          </Slide>
          <div className={classes.productSection}>
            <div className={classes.gallerySection}>
              <Hidden smDown>
                <div className={classes.categorySection}>
                  <Typography
                    component={NavLink}
                    to={`/productos/${category}`}
                    className={classes.treeCategory}
                  >
                    {product.sub_sub_category.sub_category.category.name}
                  </Typography>
                  <ChevronRight />
                  <Typography
                    component={NavLink}
                    to={`/productos/${category}/${subCategory}`}
                    className={classes.treeCategory}
                  >
                    {product.sub_sub_category.sub_category.name}
                  </Typography>
                  <ChevronRight />
                  <Typography
                    component={NavLink}
                    to={`/productos/${category}/${subCategory}/${subSubCategory}`}
                    className={classes.treeCategorySelected}
                  >
                    {product.sub_sub_category.name}
                  </Typography>
                </div>
              </Hidden>
              <Hidden mdUp>
                {product.views !== 0 && (
                  <div
                    className={classes.visitsSection}
                    style={{ justifyContent: 'center', margin: '4px' }}
                  >
                    <SvgIcon className={classes.eyeIcon} fontSize="small">
                      <EyeIcon />
                    </SvgIcon>
                    <Typography>
                      {abbreviateNumbers(product.views, 1)} chicas vieron este
                      producto
                    </Typography>
                  </div>
                )}
              </Hidden>
              <Gallery
                product={product}
                images={[product.main_image, ...product.secondary_images]}
              />
            </div>
            <Hidden smDown>
              <div className={classes.profileSection}>
                <div className={classes.profileMiniature}>
                  <UserCard
                    extended={this.props.width !== 'xs'}
                    user={product.user}
                  />
                </div>
              </div>
            </Hidden>
            <div className={classes.purchaseSection}>
              <Hidden smDown>
                {product.views !== 0 && (
                  <div className={classes.visitsSection}>
                    <SvgIcon className={classes.eyeIcon} fontSize="small">
                      <EyeIcon />
                    </SvgIcon>
                    <Typography>
                      {abbreviateNumbers(product.views, 1)} chicas vieron este
                      producto
                    </Typography>
                  </div>
                )}
              </Hidden>
              <Typography
                style={{
                  fontWeight: 600,
                  color: '#000',
                  marginBottom: 0
                }}
                variant="h4"
              >
                {product.title}
              </Typography>
              <div className={classes.priceSection}>
                <Typography
                  className={
                    product.original_price !== product.selling_price
                      ? classes.strikedText
                      : classes.primaryPrice
                  }
                  variant={
                    product.original_price !== product.selling_price
                      ? 'h6'
                      : 'h5'
                  }
                >
                  ${numberWithCommas(product.original_price)}
                </Typography>
                {product.original_price !== product.selling_price && (
                  <Typography
                    className={
                      primaryPrice !== product.selling_price
                        ? classes.strikedText
                        : classes.primaryPrice
                    }
                    variant={
                      primaryPrice !== product.selling_price ? 'h6' : 'h5'
                    }
                  >
                    ${numberWithCommas(product.selling_price)}
                  </Typography>
                )}
                {primaryPrice !== product.selling_price && (
                  <Typography
                    variant="h5"
                    className={`${classes.primaryPrice} ${classes.offerPrice}`}
                  >
                    ${numberWithCommas(primaryPrice)}
                  </Typography>
                )}
                {calculateDiscount(product.original_price, primaryPrice) !==
                  0 && (
                  <Typography variant="h6" className={classes.discountAmount}>
                    {calculateDiscount(product.original_price, primaryPrice)}%
                    OFF
                  </Typography>
                )}
              </div>
              <div className={classes.productDetail}>
                <Typography style={{ fontWeight: 500, fontSize: '1.1rem' }}>
                  {i18next.t('size')} {product.size.name} ·{' '}
                  {translateCondition(product.condition)}
                  {product.color ? ' · ' : ''}
                </Typography>
                {product.color !== null && (
                  <ColorSelector
                    nonInteractive
                    color={product.color}
                    size={25}
                  />
                )}
              </div>
              {discount !== null && (
                <div className={classes.discountSection}>{discount.render}</div>
              )}
              <ProductTags tags={product.tags} />
              <Typography
                className={classes.description}
                variant="body1"
                component="span"
              >
                {product.description &&
                product.description.length > 140 &&
                !this.state.openDescription ? (
                  <>
                    {product.description.substring(0, 140)}...
                    <Link
                      onClick={() => this.setState({ openDescription: true })}
                      className={classes.seeMore}
                    >
                      ver más
                    </Link>
                  </>
                ) : (
                  <Typography style={{ textAlign: 'justify' }}>
                    {product.description}
                  </Typography>
                )}
              </Typography>
              {product.status === 'STATUS_RESERVED' && (
                <Typography color="primary" style={{ fontWeight: 600 }}>
                  RESERVADO
                </Typography>
              )}
              <div className={classes.purchaseButtonGroup}>
                {!product.user.roles.includes('ROLE_SHOWROOM') &&
                  product.status === 'STATUS_LIVE' && (
                    <OfferButton product={product}>
                      <Button
                        variant="contained"
                        className={classes.secondaryButton}
                        disabled={
                          (product.offers.length &&
                            product.offers[0].status === 'STATUS_LIVE') ||
                          (this.props.user &&
                            this.props.user.id === product.user.id)
                        }
                      >
                        Ofertar
                        <SvgIcon
                          className={classes.buttonIcon}
                          viewBox="0 0 34.587 35.882"
                        >
                          <HammerIcon />
                        </SvgIcon>
                      </Button>
                    </OfferButton>
                  )}
                <Button
                  variant="contained"
                  className={classes.secondaryButton}
                  onClick={this.scrollIntoComments}
                  style={
                    product.user.roles.includes('ROLE_SHOWROOM') ||
                    product.status === 'STATUS_RESERVED'
                      ? { gridColumn: '1 / 3' }
                      : {}
                  }
                >
                  Comentar
                  <SvgIcon className={classes.buttonIcon} color="primary">
                    <MessageIcon />
                  </SvgIcon>
                </Button>
                <VisibilitySensor
                  partialVisibility
                  offset={{ top: 76 + 45 / 2 }}
                  scrollCheck
                  onChange={this.visibilityChange}
                >
                  <>
                    {product.status !== 'STATUS_RESERVED' && (
                      <Button
                        style={{ gridColumn: '1 / 3' }}
                        variant="contained"
                        color="primary"
                        disabled={
                          (this.props.user &&
                            this.props.user.id === product.user.id) ||
                          product.status !== 'STATUS_LIVE'
                        }
                        className={classes.purchaseButton}
                        onClick={this.handlePurchase}
                      >
                        {product.status === 'STATUS_FINISHED'
                          ? 'VENDIDO'
                          : 'COMPRAR'}
                      </Button>
                    )}
                    {product.status === 'STATUS_RESERVED' && (
                      <RTVNotifyAvailability
                        buttonProps={{
                          style: { gridColumn: '1 / 3' },
                          variant: 'contained',
                          color: 'primary'
                        }}
                        user={this.props.user}
                        product={product}
                      />
                    )}
                  </>
                </VisibilitySensor>
              </div>
              <Shipping
                product={this.props.product.id}
                user={this.props.product.user}
              />
            </div>
            <Hidden mdUp>
              <div className={classes.profileSection}>
                <div className={classes.profileMiniature}>
                  <UserCard
                    fullWidth
                    extended={this.props.width !== 'xs'}
                    user={product.user}
                  />
                </div>
              </div>
            </Hidden>
          </div>
          <Comments
            productUser={this.props.product.user}
            product={this.props.product.id}
            disabled={
              product.status !== 'STATUS_LIVE' &&
              product.status !== 'STATUS_RESERVED'
            }
          />
        </div>
        <FaqSection />
        <ProductCarousel
          brand={this.props.product.brand}
          user={this.props.product.user}
          subSubCategory={this.props.product.sub_sub_category}
        />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  shoppingCart: state.user.shoppingCart,
  product: state.product.product,
  cartStatus: state.user.status,
  status: state.product.status,
  privateStats: state.user.privateStats,
  error: state.product.error,
  loggedInUser: state.auth.user,
  isLoggedIn: state.auth.isLoggedIn
});

const mapDispatchToProps = dispatch => ({
  push: path => dispatch(push(path)),
  getProduct: productID => dispatch(getProduct(productID)),
  getCart: () => dispatch(getCart()),
  addToCart: product => dispatch(addToCart(product)),
  expressToggle: (toggle, fromAction) =>
    dispatch(expressToggle(toggle, fromAction))
});

export default withStyles(styles)(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(withWidth()(Product)))
);
